import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid, Button, TextField } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import TdsVerification from './tdsVerification';
import BVerification from './43BVerification';
import OtherClauses3cd from './otherClauses3Cd';
// import BankVerification from './BankVerification';
// import AuditOfLoans from './AuditOfLoans';
// import AuditOfOtherLoans from './AuditOfOtherLoans';
// import AuditOfCapital from './AuditOfCapital';
// import PayrollAudit from './PayrollAudit';
// import InventoryAudit from './InventoryAudit';
// import FixedAssets from './FixedAssets';
// import AuditOfInvestments from './AuditOfInvestments';
// import OtherAssetAndLiabilityAudit from './OtherAssetAndLiabilityAudit';
// import Cash from './Cash';
// import ForeignAssets from './foreignAssets';
// import './styles.css';
// import DifferentSource from './differentSource';
// import TotalIncome from './totalIncome';
// import IncomeTaxPassword from './incomeTax';
// import TravelledOutsideIndia from './travelledOutside';
// import Director from './directorInIndia';
// import AdditionalQuestions from './additionalQuestions';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '2%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    cardCustom: {
        padding: '0',
    },
    displayInline: {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0,
        '& li': {
            display: 'inline-block',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        marginTop: '25px',
        width: '100%',
    },
}));
// function StyledRadio(props) {
//     const classes = useStyles();

//     return (
//         <Radio
//             className={classes.root}
//             disableRipple
//             color="default"
//             checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
//             icon={<span className={classes.icon} />}
//             {...props}
//         />
//     );
// }
export default function Accordin(props, values) {
    const classes = useStyles();
    // const [selectedValue, setSelectedValue] = React.useState('a');

    const [generalInformation, setGeneralInformationData] = useState([]);

    //console.log('generalInformation', generalInformation);
    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    // const handleChange = (event) => {
    //     setSelectedValue(event.target.value);
    // };

    return (
        <>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <CardHeader className="borderBottomLine ptb24" title="Tax Audit Process Checklist" />
                    <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header" className="padding10">
                            <Typography className={classes.heading}>TDS Verification</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <TdsVerification />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            className="padding10"
                        >
                            <Typography className={classes.heading}>43B Verification</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <BVerification />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                            className="padding10"
                        >
                            <Typography className={classes.heading}>Other clauses in 3CD</Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.accordContentSummary}>
                            <OtherClauses3cd />
                        </AccordionDetails>
                    </Accordion>
                    <Grid container spacing={3} className="mt20p">
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="startdate" shrink>
                                    Other clauses
                                </InputLabel>
                                <TextField className="textfieldBottomLine w100" defaultValue="Enter Remarks" multiline rows={1} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl className={classes.btnspace}>
                                <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                    Attach document
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Grid item sm={12} className={classes.fullWidth}>
                <div>
                    <ul className={classes.displayInline}>
                        <li>
                            <Button variant="contained" className="btnBlue ml10 txt-cap" color="primary">
                                Submit
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
            {/* <div className={classes.root}>
            <div>
                <Grid container spacing={3} className="main-container">
                    <Grid item xs={12} sm={6}>
                        <Typography>Audit Checklist</Typography>
                    </Grid>                   
                </Grid>
            </div>
  </div> */}
        </>
    );
}
